var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_554",
    "data-name": "Group 554",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.482,
    height: 15.482,
    viewBox: "0 0 15.482 15.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M0,0H15.482V15.482H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M8.451,14.9A6.451,6.451,0,1,1,14.9,8.451,6.451,6.451,0,0,1,8.451,14.9ZM5.225,8.451a3.225,3.225,0,1,0,6.451,0h-1.29a1.935,1.935,0,1,1-3.87,0Z",
    transform: "translate(-0.71 -0.71)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.7f38608924373b0d5426842a1030136c.svg";
export { ForwardRef as ReactComponent };